import { Box, CardContent, Link, Typography, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { API } from '../../interceptors/axios'

const CardUpdates = ({ updateImageId, updateTitle, updateContent, updateDate }) => {
  const [image, setImage] = useState([])

  const StyledCard = styled(Box)({    
    display: "flex",
    justifyContent: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: 600,
    width: 450
  });


  const fetchImage = async () => {      
      try {
          if (typeof updateImageId === 'undefined') return null;
          
          const token = localStorage.getItem("token");
          if (!token) {
              console.error('No token available');
              return null;
          }

          // Let the axios interceptor handle service auth
          const res = await API.get(
              `/image/${updateImageId}`, 
              {
                  responseType: 'blob',
                  headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'image/png'
                  }
              }
          );

          const blob = new Blob([res.data], { type: 'image/png' });
          const imageUrl = URL.createObjectURL(blob);
          setImage(imageUrl);

      } catch (error) {
          console.error("Error during image fetch:", error);
      }
  };

  useEffect(() => {
    // const API = axios.create({
    //   baseURL: process.env.REACT_APP_API_URL,
    //   withCredentials: true,
    // })
    
    // axios.defaults.headers.authorization = `Bearer ${token}`;

    fetchImage()

    return () => {
      // console.log('This will be logged on unmount');
    };
  }, [])

  return (
    <Box>
      <Link        
        sx={{ textDecoration: "none" }}>
        {" "}
        <CardContent>
          <Typography
            gutterBottom
            variant="h3"
            component="div"
            color={"white"}>
               {updateTitle}
          </Typography>
          <Typography
            gutterBottom
            variant="body1"
            component="div"
            color={"white"}>
                {updateDate}
          </Typography>
          <Typography 
            gutterBottom color={"black"} 
            variant="body1" 
            component="div"
            backgroundColor="white">            
                {updateContent}
          </Typography>
        </CardContent>
        <StyledCard
          sx={{
            backgroundImage: `url(${image})`,           
          }}>
        </StyledCard>
      </Link>      
    </Box>
  );
};

export default CardUpdates;